module.exports = __webpack_public_path__ + "media/application/images/svgs/donate-e08bf10d2c4dd15aa89ed7a8275a2078.svg";